export default "__VITE_ASSET__DwJGrzGN__"